/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ResourceGroup } from '../models/resource-group';
import { ResourceGroupRequest } from '../models/resource-group-request';
import { Response } from '../models/response';
import { ResourceInfo } from '../models/resource-info';

/**
 * Ui Resource Group Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiResourceGroupControllerService extends __BaseService {
  static readonly findAllUsingGETPath = '/cc-ui/v1/resource-groups';
  static readonly createUsingPOSTPath = '/cc-ui/v1/resource-groups';
  static readonly getResourceGroupsForSessionUserUsingGETPath =
    '/cc-ui/v1/resource-groups/me';
  static readonly getResourceGroupUsingGETPath =
    '/cc-ui/v1/resource-groups/{resourceGroupId}';
  static readonly updateUsingPUT1Path =
    '/cc-ui/v1/resource-groups/{resourceGroupId}';
  static readonly deleteUsingDELETE1Path =
    '/cc-ui/v1/resource-groups/{resourceGroupId}';
  static readonly updateAllResourcesUsingPUTPath =
    '/cc-ui/v1/resource-groups/{resourceGroupId}/resources';
  static readonly updateResourceUsingPATCHPath =
    '/cc-ui/v1/resource-groups/{resourceGroupId}/resources';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * findAll
   * @return OK
   */
  findAllUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ResourceGroup>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/resource-groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResourceGroup>>;
      }),
    );
  }
  /**
   * findAll
   * @return OK
   */
  findAllUsingGET(): __Observable<Array<ResourceGroup>> {
    return this.findAllUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ResourceGroup>),
    );
  }

  /**
   * create
   * @param resourceGroupRequest resourceGroupRequest
   * @return OK
   */
  createUsingPOSTResponse(
    resourceGroupRequest: ResourceGroupRequest,
  ): __Observable<__StrictHttpResponse<ResourceGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = resourceGroupRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/resource-groups`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceGroup>;
      }),
    );
  }
  /**
   * create
   * @param resourceGroupRequest resourceGroupRequest
   * @return OK
   */
  createUsingPOST(
    resourceGroupRequest: ResourceGroupRequest,
  ): __Observable<ResourceGroup> {
    return this.createUsingPOSTResponse(resourceGroupRequest).pipe(
      __map((_r) => _r.body as ResourceGroup),
    );
  }

  /**
   * getResourceGroupsForSessionUser
   * @return OK
   */
  getResourceGroupsForSessionUserUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<ResourceGroup>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/resource-groups/me`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ResourceGroup>>;
      }),
    );
  }
  /**
   * getResourceGroupsForSessionUser
   * @return OK
   */
  getResourceGroupsForSessionUserUsingGET(): __Observable<
    Array<ResourceGroup>
  > {
    return this.getResourceGroupsForSessionUserUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<ResourceGroup>),
    );
  }

  /**
   * getResourceGroup
   * @param resourceGroupId resourceGroupId
   * @return OK
   */
  getResourceGroupUsingGETResponse(
    resourceGroupId: string,
  ): __Observable<__StrictHttpResponse<ResourceGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/resource-groups/${encodeURIComponent(
          String(resourceGroupId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceGroup>;
      }),
    );
  }
  /**
   * getResourceGroup
   * @param resourceGroupId resourceGroupId
   * @return OK
   */
  getResourceGroupUsingGET(
    resourceGroupId: string,
  ): __Observable<ResourceGroup> {
    return this.getResourceGroupUsingGETResponse(resourceGroupId).pipe(
      __map((_r) => _r.body as ResourceGroup),
    );
  }

  /**
   * update
   * @param params The `UiResourceGroupControllerService.UpdateUsingPUT1Params` containing the following parameters:
   *
   * - `resourceGroupRequest`: resourceGroupRequest
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * @return OK
   */
  updateUsingPUT1Response(
    params: UiResourceGroupControllerService.UpdateUsingPUT1Params,
  ): __Observable<__StrictHttpResponse<ResourceGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.resourceGroupRequest;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/resource-groups/${encodeURIComponent(
          String(params.resourceGroupId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceGroup>;
      }),
    );
  }
  /**
   * update
   * @param params The `UiResourceGroupControllerService.UpdateUsingPUT1Params` containing the following parameters:
   *
   * - `resourceGroupRequest`: resourceGroupRequest
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * @return OK
   */
  updateUsingPUT1(
    params: UiResourceGroupControllerService.UpdateUsingPUT1Params,
  ): __Observable<ResourceGroup> {
    return this.updateUsingPUT1Response(params).pipe(
      __map((_r) => _r.body as ResourceGroup),
    );
  }

  /**
   * delete
   * @param resourceGroupId resourceGroupId
   * @return OK
   */
  deleteUsingDELETE1Response(
    resourceGroupId: string,
  ): __Observable<__StrictHttpResponse<Response>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/resource-groups/${encodeURIComponent(
          String(resourceGroupId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Response>;
      }),
    );
  }
  /**
   * delete
   * @param resourceGroupId resourceGroupId
   * @return OK
   */
  deleteUsingDELETE1(resourceGroupId: string): __Observable<Response> {
    return this.deleteUsingDELETE1Response(resourceGroupId).pipe(
      __map((_r) => _r.body as Response),
    );
  }

  /**
   * updateAllResources
   * @param params The `UiResourceGroupControllerService.UpdateAllResourcesUsingPUTParams` containing the following parameters:
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * - `allResourcesUpdateRequest`: allResourcesUpdateRequest
   *
   * @return OK
   */
  updateAllResourcesUsingPUTResponse(
    params: UiResourceGroupControllerService.UpdateAllResourcesUsingPUTParams,
  ): __Observable<__StrictHttpResponse<ResourceGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.allResourcesUpdateRequest;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/resource-groups/${encodeURIComponent(
          String(params.resourceGroupId),
        )}/resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceGroup>;
      }),
    );
  }
  /**
   * updateAllResources
   * @param params The `UiResourceGroupControllerService.UpdateAllResourcesUsingPUTParams` containing the following parameters:
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * - `allResourcesUpdateRequest`: allResourcesUpdateRequest
   *
   * @return OK
   */
  updateAllResourcesUsingPUT(
    params: UiResourceGroupControllerService.UpdateAllResourcesUsingPUTParams,
  ): __Observable<ResourceGroup> {
    return this.updateAllResourcesUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as ResourceGroup),
    );
  }

  /**
   * updateResource
   * @param params The `UiResourceGroupControllerService.UpdateResourceUsingPATCHParams` containing the following parameters:
   *
   * - `resourceUpdateRequest`: resourceUpdateRequest
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * @return OK
   */
  updateResourceUsingPATCHResponse(
    params: UiResourceGroupControllerService.UpdateResourceUsingPATCHParams,
  ): __Observable<__StrictHttpResponse<ResourceGroup>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.resourceUpdateRequest;

    let req = new HttpRequest<any>(
      'PATCH',
      this.rootUrl +
        `/cc-ui/v1/resource-groups/${encodeURIComponent(
          String(params.resourceGroupId),
        )}/resources`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ResourceGroup>;
      }),
    );
  }
  /**
   * updateResource
   * @param params The `UiResourceGroupControllerService.UpdateResourceUsingPATCHParams` containing the following parameters:
   *
   * - `resourceUpdateRequest`: resourceUpdateRequest
   *
   * - `resourceGroupId`: resourceGroupId
   *
   * @return OK
   */
  updateResourceUsingPATCH(
    params: UiResourceGroupControllerService.UpdateResourceUsingPATCHParams,
  ): __Observable<ResourceGroup> {
    return this.updateResourceUsingPATCHResponse(params).pipe(
      __map((_r) => _r.body as ResourceGroup),
    );
  }
}

module UiResourceGroupControllerService {
  /**
   * Parameters for updateUsingPUT1
   */
  export interface UpdateUsingPUT1Params {
    /**
     * resourceGroupRequest
     */
    resourceGroupRequest: ResourceGroupRequest;

    /**
     * resourceGroupId
     */
    resourceGroupId: string;
  }

  /**
   * Parameters for updateAllResourcesUsingPUT
   */
  export interface UpdateAllResourcesUsingPUTParams {
    /**
     * resourceGroupId
     */
    resourceGroupId: string;

    /**
     * allResourcesUpdateRequest
     */
    allResourcesUpdateRequest: Array<ResourceInfo>;
  }

  /**
   * Parameters for updateResourceUsingPATCH
   */
  export interface UpdateResourceUsingPATCHParams {
    /**
     * resourceUpdateRequest
     */
    resourceUpdateRequest: ResourceInfo;

    /**
     * resourceGroupId
     */
    resourceGroupId: string;
  }
}

export { UiResourceGroupControllerService };
